<template>
  <div class="load-save">
    <SaveButton
      v-bind:mode="mode"
      v-bind:screens="screens"
      v-bind:screenSet="screenSet"
      :valuesSource="valuesSource"
      v-bind:isSaved="isSaved"
      v-bind:callback="callback"
    />
    <LoadButton/>
    <b-tooltip label="Export screens to Eclipse" v-if="this.$root && this.$root.advisor && this.$root.advisor.hasFeature('Orion Values')">
      <a v-on:click="eclipseExportValues">
        <img v-bind:src="`${$root.$data.STATIC_ROOT}images/integrations/orion_export.png`">
      </a>
    </b-tooltip>

<!--     <div class="portfolio-values-button">
      <b-tooltip label="Load a screens associated with a Portfolio.">
        <b-icon
          pack="fas"
          icon="user-edit"
          label="Load Screens"
          v-on:click.native="openPortfolioValuesModal"
        />
      </b-tooltip>
    </div>
 -->  </div>
</template>

<script>
import LoadButton from './LoadButton.vue';
import SaveButton from './SaveButton.vue';
import LoadValuesModal from './LoadValuesModal.vue';

import eventBus from '@frontend/shared/EventBus.js';

export default {
  data() {
    return {
      loadedValuesFromQuerystring: false,
    }
  },
  props: {
    mode: String,
    screens: Object,
    screenSet: Object,
    valuesSource: Object,
    isSaved: Boolean,
    callback: Function,
  },
  components: {
    LoadButton, SaveButton,
  },
  methods: {
    openPortfolioValuesModal: function() {
      this.$buefy.modal.open({
        parent: this,
        component: LoadValuesModal,
        hasModalCard: true,
        trapFocus: true,
        props: {}
      })
    },
    eclipseExportValues: async function() {
      const activeScreens = this.screens.a.filter((screen)=> {
        return(screen.userPercentile > 0)
      })
      const theme_code = prompt("Please enter the ESG Screen Theme Code from Eclipse.")
      fetch(`/api/v1/export_screents_to_eclipse`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': this.$root.$data.csrfToken,
        },
        body: JSON.stringify({
          'theme_code': theme_code,
          'metric_thresholds': activeScreens.map((itm) => {
            return {
              'metric_description_id': itm.id,
              'threshold': itm.userPercentile / 100,
            }
          })
        })}).then((response) => {
          r = response.json();
          if(r['success']) {
            alert("Suceeded")
          } else {
            alert("Error: " + r['error'])
          }
        })
    },
    selectPortfolio: async function(portfolioId, allUrlParams) {
      let setId, setName;
      let pathName = portfolioId.startsWith('shareowner_') ? 'portfolios' : 'prospects';
      let response = await fetch(`/api/v1/${pathName}/${portfolioId}/`);
      let data = await response.json();
      let obj = data[pathName === 'portfolios' ? 'portfolio' : 'prospect']; // gross

      if (allUrlParams) {
        // Screensets and such can be passed into the company screener via params, but if this component is
        // embedded somewhere else we want to be able to just infer the screenset from the client
        setId = allUrlParams.get('screen_set') ? allUrlParams.get('screen_set') : null;
        setName = `Values from ${obj.name}`;
      }
      else {
        if (obj.screen_sets.length === 1 && !obj.screen_sets[0].is_template && !obj.screen_sets[0].internal_identifier) {
          setId = obj.screen_sets[0].id;
          setName = obj.screen_sets[0].name;
        }
        else {
          setName = `Values from ${obj.name}`;
        }
      }

      let fakeScreenset = {
        name: setName,
        is_dndx: true,
        id: setId,
        metrics: obj.screen_sets.reduce((acc, itm) => {
          acc = acc.concat(itm.metrics);
          return acc;
        }, [])
      }

      this.$root.$emit('loaded-screenset', fakeScreenset, true);
    }
  },
  watch: {
    'screens.a': function(oldValue, newValue) {
      if (!this.loadedValuesFromQuerystring) {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('values_from')) {
          this.selectPortfolio(urlParams.get('values_from'), urlParams);
        }
        this.loadedValuesFromQuerystring = true;
      }
    }
  },
  mounted: async function() {
    eventBus.$on('CompanyScreener:values-portfolio-selected', this.selectPortfolio);
  }
}
</script>

<style lang="scss">
.load-save {
  margin-bottom: 15px;
  display: flex;
  font-size: 17px;

  .portfolio-values-button {
    margin-left: 5px;
  }
}
</style>
